module.exports = __webpack_public_path__ + "static/media/ZTA.87d8cd4d.pdf";